"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateRemainingFundsInDays = void 0;
const frequencyToText_1 = require("./frequencyToText");
function estimateRemainingFundsInDays(community) {
    const { beneficiaries, fundsOnContract, baseInterval, claimAmount } = community;
    if (fundsOnContract < claimAmount) {
        return 0;
    }
    let communityLimitPerDay = claimAmount * beneficiaries;
    if ((0, frequencyToText_1.frequencyToText)(baseInterval) === 'week') {
        communityLimitPerDay /= 6;
    }
    return Math.max(1, Math.floor(fundsOnContract / communityLimitPerDay));
}
exports.estimateRemainingFundsInDays = estimateRemainingFundsInDays;
//# sourceMappingURL=estimateRemainingFundsInDays.js.map